import React from 'react';
import { default as TextFieldMaterial, TextFieldProps } from '@material-ui/core/TextField';
import { makeLabelClasses, makeOutlinedInputClasses } from 'styles/components/textField';

const TextField: React.FC<TextFieldProps> = props => {
    const labelClasses = makeLabelClasses();
    const outlinedInputClasses = makeOutlinedInputClasses();

    return (
        <TextFieldMaterial
            InputLabelProps={{
                classes: labelClasses,
                shrink: true,
            }}
            InputProps={{
                classes: outlinedInputClasses,
            }}
            {...props}
        />
    );
};

export default TextField;
